/**
 * ModalButton component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Props from '@shared/types/props/pressable';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled modal button.
 */
const ModalButton = styled.button<Props>`
  background: ${(props) =>
    props.displayBackground ? `${Colors['modal']['button']['light']}` : 'none'};
  border: ${Colors['modal']['button']['light']} ${3 * Screen.widthRatio}px solid;
  border-radius: ${40 * Screen.widthRatio}px;
  color: ${(props) =>
    props.displayBackground
      ? `${Colors['modal']['button']['text']}`
      : `${Colors['modal']['button']['light']}`};
  cursor: pointer;
  font-family: ${Fonts['regular']};
  font-size: ${34 * Screen.widthRatio}px;
  height: ${80 * Screen.widthRatio}px;
  margin: 0 ${15 * Screen.widthRatio}px;
  width: ${350 * Screen.widthRatio}px;
  z-index: 1;
  &:hover {
    background: ${Colors['modal']['button']['light']};
    color: ${Colors['modal']['button']['text']};
  }
`;

export default withOpacity(ModalButton);
